"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _send = require("@/api/cms/send");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'AllOrders',
  data: function data() {
    return {
      tableLoading: false,
      searchLoading: false,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      searchForm: {
        contractNo: '',
        custName: '',
        customerPhone: '',
        custAddress: '',
        productionOrder: '',
        dealer: '',
        scheduledDeliveryDate: '',
        stockInDate: ''
      },
      dataList: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      detailVisible: false,
      detailRow: null,
      activeStatus: null,
      checkedKeys: {},
      showStockInDropdown: false,
      statusTabs: [{
        label: '全部',
        value: null,
        count: 0
      }, {
        label: '已退回',
        value: '已退回',
        count: 0
      }, {
        label: '待审图',
        value: '待审图',
        count: 0
      }, {
        label: '待拆单审核',
        value: '待拆单审核',
        count: 0
      }, {
        label: '待报价审核',
        value: '待报价审核',
        count: 0
      }, {
        label: '待经销商确认',
        value: '待经销商确认',
        count: 0
      }, {
        label: '待财务审核',
        value: '待财务审核',
        count: 0
      }, {
        label: '待生产计划',
        value: '待生产计划',
        count: 0
      }, {
        label: '待排产',
        value: '待排产',
        count: 0
      }, {
        label: '待入库',
        value: '待入库',
        count: 0
      }, {
        label: '已入库',
        value: '已入库',
        count: 0
      }]
    };
  },
  computed: {
    isAllChecked: function isAllChecked() {
      var _this = this;

      if (this.dataList.length === 0) return false;
      return this.dataList.every(function (row) {
        return _this.isParentChecked(row);
      });
    },
    isAllIndeterminate: function isAllIndeterminate() {
      var _this2 = this;

      if (this.dataList.length === 0) return false;
      var checkedCount = this.dataList.filter(function (row) {
        return _this2.isParentChecked(row);
      }).length;
      var indeterminateCount = this.dataList.filter(function (row) {
        return _this2.isParentIndeterminate(row);
      }).length;
      return checkedCount > 0 && checkedCount < this.dataList.length || indeterminateCount > 0;
    },
    hasAnySelection: function hasAnySelection() {
      var _this3 = this;

      return this.dataList.some(function (row) {
        return (row.contractList || []).some(function (c) {
          return _this3.checkedKeys[c._rowKey] && c.id != null;
        });
      });
    },
    dialogWidth: function dialogWidth() {
      var screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
      return screenWidth * 0.7 + 'px';
    },
    tableHeight: function tableHeight() {
      return this.screenHeight * 0.55;
    },
    tableColumns: function tableColumns() {
      return [{
        prop: 'dealerShopName',
        label: '经销商',
        minWidth: 120
      }, {
        prop: 'contractNo',
        label: '合同号',
        minWidth: 140
      }, {
        prop: 'orderNo',
        label: '订单号',
        minWidth: 140
      }, {
        prop: 'productionStatus',
        label: '订单状态',
        minWidth: 110
      }, {
        prop: 'orderType',
        label: '订单类型',
        minWidth: 140
      }, {
        prop: 'custName',
        label: '客户姓名',
        minWidth: 100
      }, {
        prop: 'custMobile',
        label: '电话',
        minWidth: 120
      }, {
        prop: 'custAddress',
        label: '客户地址',
        minWidth: 160
      }, {
        prop: 'guideNickName',
        label: '销售员',
        minWidth: 100,
        type: 'jsonArray'
      }, {
        prop: 'designerNickName',
        label: '设计师',
        minWidth: 100,
        type: 'jsonArray'
      }, {
        prop: 'volume',
        label: '柜数',
        minWidth: 80
      }, {
        prop: 'signingTime',
        label: '签单日期',
        minWidth: 110,
        type: 'date'
      }, {
        prop: 'confirmPlanTime',
        label: '方案确认日期',
        minWidth: 120,
        type: 'date'
      }, {
        prop: 'agreedConstructionPeriod',
        label: '合同约定工期(天)',
        minWidth: 140
      }, {
        prop: 'agreedConstructionPeriod2',
        label: '合同约定工期',
        minWidth: 120,
        type: 'date'
      }, {
        prop: 'amount',
        label: '合同金额',
        minWidth: 110,
        align: 'right',
        type: 'money'
      }, {
        prop: 'amountReceived',
        label: '实收金额',
        minWidth: 110,
        align: 'right',
        type: 'money'
      }, {
        prop: 'paymentRatio',
        label: '收款比例',
        minWidth: 100
      }, {
        prop: 'productName',
        label: '产品名称',
        minWidth: 120
      }, {
        prop: 'color',
        label: '板材花色',
        minWidth: 140,
        align: 'left'
      }, {
        prop: 'stone',
        label: '石材材料',
        minWidth: 120
      }, {
        prop: 'stoneColor',
        label: '石材颜色',
        minWidth: 120,
        align: 'left'
      }, {
        prop: 'basinSource',
        label: '水盆来源',
        minWidth: 110
      }, {
        prop: 'basinQuantity',
        label: '水盆数量',
        minWidth: 100
      }, {
        prop: 'basinModel',
        label: '水盆型号',
        minWidth: 120
      }, {
        prop: 'faucetSource',
        label: '龙头来源',
        minWidth: 110
      }, {
        prop: 'faucetQuantity',
        label: '龙头数量',
        minWidth: 100
      }, {
        prop: 'faucetModel',
        label: '龙头型号',
        minWidth: 120
      }, {
        prop: 'specialProcessCycle',
        label: '特殊工艺生产周期',
        minWidth: 140
      }, {
        prop: 'specialProcessDelivery',
        label: '特殊工艺生产交期',
        minWidth: 140,
        type: 'date'
      }, {
        prop: 'specialProcessApply',
        label: '特殊工艺申请',
        minWidth: 130
      }, {
        prop: 'createUserName',
        label: '下单人',
        minWidth: 100
      }, {
        prop: 'orderClerkTime',
        label: '下单时间',
        minWidth: 160
      }, {
        prop: 'auditorName',
        label: '审图人',
        minWidth: 100
      }, {
        prop: 'approveOrderTime',
        label: '审图时间',
        minWidth: 160
      }, {
        prop: 'dismantlePerson',
        label: '拆单人',
        minWidth: 100
      }, {
        prop: 'dismantleTime',
        label: '拆单时间',
        minWidth: 160
      }, {
        prop: 'quotePerson',
        label: '报价人',
        minWidth: 100
      }, {
        prop: 'approveQuoteTime',
        label: '报价时间',
        minWidth: 160
      }, {
        prop: 'payPerson',
        label: '经销商确认人',
        minWidth: 100
      }, {
        prop: 'approveFinanceTime',
        label: '经销商确认时间',
        minWidth: 160
      }, {
        prop: 'receivePerson',
        label: '财务审核人',
        minWidth: 100
      }, {
        prop: 'receiveTime',
        label: '财务审核时间',
        minWidth: 160
      }, {
        prop: 'planPerson',
        label: '排生产计划人',
        minWidth: 100
      }, {
        prop: 'palnProductionTime',
        label: '排生产计划时间',
        minWidth: 160
      }, {
        prop: 'shipmentDatePromise',
        label: '承诺交货日期',
        minWidth: 160
      }, {
        prop: 'productionStartDateTime',
        label: '开始生产日期',
        minWidth: 160
      }, {
        prop: 'completeSetDate',
        label: '齐套入库时间',
        minWidth: 160
      }, {
        prop: 'actualOutTime',
        label: '出库时间',
        minWidth: 160
      }, {
        prop: 'totalArea',
        label: '总面积',
        minWidth: 100
      }, {
        prop: 'expandArea',
        label: '展开面积',
        minWidth: 100
      }, {
        prop: 'stoneLeng',
        label: '房门面积',
        minWidth: 100
      }, {
        prop: '',
        label: '台面米数',
        minWidth: 100
      }, {
        prop: 'totalPack',
        label: '总包数',
        minWidth: 100
      }, {
        prop: 'inPack',
        label: '入库包数',
        minWidth: 100
      }, {
        prop: 'warehouse',
        label: '仓库',
        minWidth: 100
      }, {
        prop: 'storage',
        label: '库位',
        minWidth: 100
      }];
    }
  },
  mounted: function mounted() {
    this.handleSearch();
    this.fetchStatusCounts();
    window.addEventListener('resize', this.handleResize);
  },
  activated: function activated() {
    this.handleSearch();
    this.fetchStatusCounts();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    fetchStatusCounts: function fetchStatusCounts() {
      var _this4 = this;

      (0, _send.getDesignAuditStatusCounts)().then(function (response) {
        if (response.code === 200) {
          var counts = response.data || [];

          _this4.statusTabs.forEach(function (tab) {
            if (tab.value === null) {
              tab.count = counts.reduce(function (sum, c) {
                return sum + (c.count || 0);
              }, 0);
            } else if (tab.value === '已入库') {
              tab.count = counts.filter(function (c) {
                return c.productionStatus === '部分入库' || c.productionStatus === '全部入库';
              }).reduce(function (sum, c) {
                return sum + (c.count || 0);
              }, 0);
            } else {
              var found = counts.find(function (c) {
                return c.productionStatus === tab.value;
              });
              tab.count = found ? found.count : 0;
            }
          });
        }
      }).catch(function () {});
    },
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    handleStatusTabClick: function handleStatusTabClick(status) {
      this.activeStatus = status;
      this.currentPage = 1;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      this.searchLoading = true;
      this.tableLoading = true;
      this.currentPage = 1;
      this.loadData();
    },
    loadData: function loadData() {
      var _this5 = this;

      var params = {
        page: this.currentPage - 1,
        size: this.pageSize
      };
      if (this.searchForm.contractNo) params.contractNo = this.searchForm.contractNo;
      if (this.searchForm.custName) params.customerName = this.searchForm.custName;
      if (this.searchForm.customerPhone) params.customerPhone = this.searchForm.customerPhone;
      if (this.searchForm.custAddress) params.customerAddress = this.searchForm.custAddress;
      if (this.searchForm.dealer) params.dealer = this.searchForm.dealer;
      if (this.searchForm.productionOrder) params.orderNo = this.searchForm.productionOrder;
      if (this.searchForm.scheduledDeliveryDate) params.scheduledDeliveryDate = this.searchForm.scheduledDeliveryDate;
      if (this.activeStatus) params.productionStatus = this.activeStatus; // 不传 isAll

      (0, _send.getDesignAudit)(params).then(function (response) {
        if (response.code === 200) {
          _this5.checkedKeys = {};
          var content = response.data.content || [];
          _this5.dataList = content.map(function (vo, ci) {
            var items = (vo.items || []).filter(function (item) {
              return item.id != null;
            }).map(function (item, ii) {
              return _objectSpread(_objectSpread({}, item), {}, {
                _rowKey: "ao_".concat(ci, "_").concat(ii)
              });
            }); // 通过 orderNo 关联 t_order_data.order_number 获取材料数据

            var parsedMaterial = {};

            if (vo.materialData) {
              try {
                var md = typeof vo.materialData === 'string' ? JSON.parse(vo.materialData) : vo.materialData;
                if (md) parsedMaterial = md;
              } catch (_unused) {}
            }

            return _objectSpread(_objectSpread({
              _rowKey: "ao_".concat(ci)
            }, parsedMaterial), {}, {
              id: vo.contractId,
              contractNo: vo.contractNo,
              orderNo: vo.orderNo,
              orderType: parsedMaterial.orderType,
              custName: vo.contactPerson,
              custMobile: vo.contactNumber,
              custAddress: vo.contactAddress,
              dealerShopName: vo.dealerShopName,
              scheduledDeliveryDate: vo.scheduledDeliveryDate,
              confirmPlanTime: vo.confirmPlanTime,
              agreedConstructionPeriod: vo.agreedConstructionPeriod,
              agreedConstructionPeriod2: vo.scheduledDeliveryDate,
              guideNickName: vo.guideNickName,
              designerNickName: vo.designerNickName,
              signingTime: vo.signingTime,
              amountReceived: vo.amountReceived,
              paymentRatio: vo.paymentRatio,
              amount: vo.amount,
              orderClerkTime: vo.auditCreateTime,
              createUserName: vo.createUserName,
              productionStatus: vo.productionStatus,
              contractList: items
            });
          });
          _this5.total = response.data.totalElements || 0;
        } else {
          _this5.$message.error(response.msg || '查询失败');
        }
      }).catch(function () {
        _this5.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this5.searchLoading = false;
        _this5.tableLoading = false;
      });
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        contractNo: '',
        custName: '',
        customerPhone: '',
        custAddress: '',
        productionOrder: '',
        dealer: '',
        scheduledDeliveryDate: '',
        stockInDate: ''
      };
      this.currentPage = 1;
      this.handleSearch();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.loadData();
    },
    formatCellValue: function formatCellValue(row, col) {
      var val = row[col.prop];
      if (val == null || val === '') return '-';
      if (col.type === 'date') return this.formatDate(val);
      if (col.type === 'money') return '¥' + this.formatMoney(val);
      if (col.type === 'jsonArray') return this.parseJsonArray(val);

      if (col.prop === 'color' || col.prop === 'stoneColor') {
        return String(val).replace(/^,+/g, '').replace(/,+$/g, '').replace(/,/g, '\n');
      }

      return val;
    },
    formatDate: function formatDate(dateStr) {
      if (!dateStr) return '-';
      return dateStr.split(' ')[0];
    },
    formatMoney: function formatMoney(val) {
      if (val == null) return '-';
      return Number(val).toFixed(2);
    },
    parseJsonArray: function parseJsonArray(val) {
      if (!val) return '-';

      try {
        var arr = JSON.parse(val);

        if (Array.isArray(arr)) {
          return arr.join('、');
        }

        return val;
      } catch (e) {
        return val;
      }
    },
    handleRowClick: function handleRowClick(row) {
      this.$refs.dataTable.toggleRowExpansion(row);
    },
    isParentChecked: function isParentChecked(parentRow) {
      var _this6 = this;

      var children = this.checkableChildren(parentRow);

      if (children.length === 0) {
        return !!this.checkedKeys[parentRow._rowKey];
      }

      return children.every(function (child) {
        return !!_this6.checkedKeys[child._rowKey];
      });
    },
    isParentIndeterminate: function isParentIndeterminate(parentRow) {
      var _this7 = this;

      var children = this.checkableChildren(parentRow);
      if (children.length === 0) return false;
      var checkedCount = children.filter(function (child) {
        return !!_this7.checkedKeys[child._rowKey];
      }).length;
      return checkedCount > 0 && checkedCount < children.length;
    },
    isParentDisabled: function isParentDisabled(parentRow) {
      return this.checkableChildren(parentRow).length === 0;
    },
    checkableChildren: function checkableChildren(parentRow) {
      if (!parentRow.contractList) return [];
      return parentRow.contractList.filter(function (c) {
        return c.isAll === '是' && c.isInitiate == null;
      });
    },
    isChildChecked: function isChildChecked(child) {
      return !!this.checkedKeys[child._rowKey];
    },
    handleSelectAll: function handleSelectAll(checked) {
      var _this8 = this;

      this.dataList.forEach(function (row) {
        _this8.setParentChecked(row, checked);
      });
    },
    setParentChecked: function setParentChecked(parentRow, checked) {
      var _this9 = this;

      if (parentRow.contractList) {
        var children = this.checkableChildren(parentRow);
        if (children.length === 0 && checked) return;
        children.forEach(function (child) {
          if (checked) {
            _this9.$set(_this9.checkedKeys, child._rowKey, true);
          } else {
            _this9.$delete(_this9.checkedKeys, child._rowKey);
          }
        });
      }

      if (checked) {
        this.$set(this.checkedKeys, parentRow._rowKey, true);
      } else {
        this.$delete(this.checkedKeys, parentRow._rowKey);
      }
    },
    handleParentCheckChange: function handleParentCheckChange(parentRow) {
      if (this.checkableChildren(parentRow).length === 0) return;
      this.setParentChecked(parentRow, !this.isParentChecked(parentRow));
    },
    handleChildCheckChange: function handleChildCheckChange(child, parentRow) {
      var _this10 = this;

      var newChecked = !this.isChildChecked(child);

      if (newChecked) {
        this.$set(this.checkedKeys, child._rowKey, true);
      } else {
        this.$delete(this.checkedKeys, child._rowKey);
      }

      var children = this.checkableChildren(parentRow);

      if (children.length > 0) {
        var allChecked = children.every(function (c) {
          return !!_this10.checkedKeys[c._rowKey];
        });

        if (allChecked) {
          this.$set(this.checkedKeys, parentRow._rowKey, true);
        } else {
          this.$delete(this.checkedKeys, parentRow._rowKey);
        }
      }
    },
    handleDeliveryInstruction: function handleDeliveryInstruction() {
      var _this11 = this;

      var selectedIds = [];
      this.dataList.forEach(function (row) {
        if (row.contractList) {
          row.contractList.forEach(function (c) {
            if (_this11.checkedKeys[c._rowKey] && c.id != null && c.isAll === '是' && c.isInitiate == null) {
              selectedIds.push(c.id);
            }
          });
        }

        if (_this11.checkedKeys[row._rowKey] && row.contractList) {
          row.contractList.forEach(function (c) {
            if (c.id != null && !selectedIds.includes(c.id) && c.isAll === '是' && c.isInitiate == null) {
              selectedIds.push(c.id);
            }
          });
        }
      });

      if (selectedIds.length === 0) {
        this.$message.warning('请先选择要发起部分发货的数据');
        return;
      }

      this.$confirm("\u786E\u5B9A\u5BF9\u9009\u4E2D\u7684 ".concat(selectedIds.length, " \u6761\u65B9\u6848\u53D1\u8D77\u90E8\u5206\u53D1\u8D27\u5417\uFF1F"), '确认发起', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.tableLoading = true;
        (0, _send.initiateOrderSolution)({
          ids: selectedIds
        }).then(function (response) {
          if (response.code === 200) {
            _this11.$message.success('发起成功');

            _this11.checkedKeys = {};

            _this11.loadData();
          } else {
            _this11.$message.error(response.msg || '发起失败');
          }
        }).catch(function () {
          _this11.$message.error('网络错误，请稍后重试');
        }).finally(function () {
          _this11.tableLoading = false;
        });
      }).catch(function () {});
    }
  }
};
exports.default = _default;